// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skeleton-form-wrapper[data-v-1db0770a]{width:100%}.skeleton-form-wrapper .skeleton-form-row[data-v-1db0770a]{margin-bottom:2rem}", ""]);
// Exports
module.exports = exports;
